export const AMAZON_DOMAIN = 'kunden.openbankpay.com';
export const API_AMAZON_DOMAIN = 'https://api.kunden.openbankpay.com/';
export const OPENBANKPAY_DOMAIN = '.openbankpay.com';
